"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdatesOnlyEffect = exports.default = void 0;
var _react = require("react");
var useUpdatesOnlyEffect = exports.useUpdatesOnlyEffect = function useUpdatesOnlyEffect(callback, deps) {
  var mounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (mounted.current) {
      callback();
    } else {
      mounted.current = true;
    }
  }, deps);
};
var _default = exports.default = useUpdatesOnlyEffect;